// extracted by mini-css-extract-plugin
module.exports = {"white":"PageLayout_white__jznkp","ice":"PageLayout_ice__FmFOx","beige":"PageLayout_beige__CZTrC"};